import { render, staticRenderFns } from "./CustomNotificationsList.vue?vue&type=template&id=3526a7ce&scoped=true&"
import script from "./CustomNotificationsList.vue?vue&type=script&lang=js&"
export * from "./CustomNotificationsList.vue?vue&type=script&lang=js&"
import style0 from "./CustomNotificationsList.vue?vue&type=style&index=0&id=3526a7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3526a7ce",
  null
  
)

export default component.exports